import { TableBody, TableCell, TableRow, toNumberString } from '@client/toolkit';
import React, { useMemo } from 'react';
import { ExpanableTableWraper } from '../../components/expanable-table-wraper';
import { useConsumptionBySourceQuery } from './consumption-source-graph';
import { getSourceDisplayName } from '../../reporting-consumption-energy-type/components/consumption-source-tag';
import { useChartResolutionDateFormat } from '../../../../components/charts/hooks/useChartLabelFormat';

function getPeriodeTableLabelByResolution(resolution?: string | null) {
  switch (resolution) {
    case 'hourly':
      return 'Time';
    case 'daily':
      return 'Dato';
    case 'weekly':
      return 'Uke';
    case 'monthly':
      return 'Måned';
    case 'yearly':
      return 'År';
    default:
      return 'Tidspunkt';
  }
}

export const ConsumptionBySourceTable: React.FC = () => {
  const { data, sources, resolution } = useConsumptionBySourceQuery();
  const { getFormat } = useChartResolutionDateFormat(resolution);
  const { columns, rows } = useMemo(() => {
    const mappedColumns = sources.map((source) => ({
      key: source,
      label: `${getSourceDisplayName(source)} (kWh)`,
    }));
    const preparedColumns = [{ key: 'periode', label: getPeriodeTableLabelByResolution(resolution) }, ...mappedColumns];
    const mappedRows = data.map((item) => ({
      id: item.key,
      columns: preparedColumns.map((column) => ({
        key: column.key,
        value:
          column.key === 'periode'
            ? getFormat(item.key)
            : item[column.key] != null
              ? toNumberString(item[column.key] as number)
              : null,
      })),
    }));
    return {
      columns: preparedColumns,
      rows: mappedRows,
    };
  }, [data, sources, resolution]);

  return (
    <>
      <ExpanableTableWraper
        columns={columns}
        data={rows}
        selectable={false}
        renderBody={(
          data,
          selectedRows,
          expandedRows,
          handleToggleSelect,
          handleKeyDownSelect,
          handleToggleExpand,
          handleKeyDownExpand,
        ) => (
          <TableBody>
            {data.map(({ id, columns }) => (
              <React.Fragment key={id}>
                <TableRow className="bg-surface-elevated/40 border-b border-surface-elevated group hover:bg-surface-elevated">
                  {columns.map((column) => (
                    <TableCell key={column.key} className="px-2 py-2 align-top">
                      {column.value ? column.value : '-'}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        )}
      />
    </>
  );
};
